<template>
  <!-- Sign In Block -->
  <div class="row no-gutters justify-content-center bg-primary-dark-op">
    <div class="hero-static col-sm-8 col-md-6 col-xl-4 d-flex align-items-center p-2 px-sm-0">
      <div class="block block-transparent block-rounded w-100 mb-0 overflow-hidden">
    <div class="block-content block-content-full px-lg-5 px-xl-6 py-4 py-md-5 py-lg-6 bg-white">
      <!-- Header -->
      <div class="mb-2 text-center">
        <router-link :to="{ name: 'welcome' }" class="link-fx font-w700 font-size-h1" href="index.html">
          <span class="text-dark">{{$t('auth.login.' + selectedChain)}}</span><span class="text-primary"> {{$t('auth.login.detective')}}</span>
        </router-link>
        <p class="text-uppercase font-w700 font-size-sm text-muted">{{$t('auth.login.signIn')}}</p>
      </div>
      <!-- END Header -->
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <button @click="loginGoogle" class="btn btn-hero-primary" :disabled="isLoading">
            <font-awesome-icon v-if="!loadingGoogle" :icon="['fab', 'google']" fixed-width class="mr-1"/><font-awesome-icon v-else icon="spinner" fixed-width class="mr-1 fa-spin"/> Google
          </button>
          <button @click="loginGithub" class="btn btn-hero-primary ml-2" :disabled="isLoading">
            <font-awesome-icon v-if="!loadingGithub" :icon="['fab', 'github']" fixed-width class="mr-1"/><font-awesome-icon v-else icon="spinner" fixed-width class="mr-1 fa-spin"/> GitHub
          </button>
        </div>
      </div>
      <hr>

      <!-- Sign In Form -->
      <form @submit.prevent="loginEmail">
        <div class="form-group">
          <div class="input-group">
            <input type="email" v-model="email" class="form-control" id="signin-email" name="signin-email" :placeholder="$t('auth.login.email')">
            <div class="input-group-append">
              <span class="input-group-text">
                <font-awesome-icon icon="envelope-open" fixed-width/>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="input-group">
            <input :type="pwInput.type" v-model="password" class="form-control" id="signup-password" name="signup-password" :placeholder="$t('auth.register.password')">
            <div @click="showPw = !showPw" class="input-group-append">
              <span class="input-group-text">
               <font-awesome-icon :icon="pwInput.icon" fixed-width/>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group d-sm-flex justify-content-sm-between align-items-sm-center text-center text-sm-left">
          <div class="font-w600 font-size-sm py-1">
            <router-link :to="{ name: 'register' }">{{$t('auth.login.createAccount')}}</router-link>
          </div>
          <div class="font-w600 font-size-sm py-1">
            <router-link :to="{ name: 'pwreset' }">{{$t('auth.login.forgotPassword')}}</router-link>
          </div>
        </div>
        <div class="form-group text-center">
          <button type="submit" class="btn btn-hero-primary" :disabled="isLoading">
            <font-awesome-icon v-if="!loadingEmail" icon="sign-in-alt" fixed-width class="mr-1"/><font-awesome-icon v-else icon="spinner" fixed-width class="mr-1 fa-spin"/> {{$t('auth.login.signIn')}}
          </button>
        </div>
        <div class="font-w600 font-size-sm py-1 text-center">
          <a @click="loginGuest" href="javascript:void(0)">{{$t('auth.login.guestLogin')}}</a>
        </div>
      </form>
      <!-- END Sign In Form -->
    </div>
  </div>
    </div>
  </div>
  <!-- END Sign In Block -->
</template>

<script>
import { mapMutations } from 'vuex'
const fb = require('@/firebaseConfig.js')

export default {
  name: 'Login',
  data () {
    return {
      loadingEmail: false,
      loadingGoogle: false,
      loadingGithub: false,
      email: '',
      password: '',
      showPw: false
    }
  },
  computed: {
    selectedChain () {
      return this.$store.state.options.selectedChain
    },
    loginToPath () {
      return this.$store.state.options.loginToPath
    },
    isLoading () {
      return this.loadingEmail || this.loadingGoogle || this.loadingGithub
    },
    pwInput () {
      if (this.showPw) return { type: 'text', icon: 'eye-slash' }
      else return { type: 'password', icon: 'eye' }
    }
  },
  methods: {
    ...mapMutations([
      'setLoginToPath',
      'setNotification'
    ]),
    loginEmail: function () {
      this.loadingEmail = true
      fb.auth.signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.loginRouteCheck()
        },
        (err) => {
          this.setNotification({
            variant: 'danger',
            message: err.message
          })
          this.loadingEmail = false
        }
      )
    },
    loginGoogle: function () {
      this.loadingGoogle = true
      fb.providerGoogle.addScope('profile')
      fb.providerGoogle.addScope('email')
      fb.auth.signInWithPopup(fb.providerGoogle)
        .then(
          (user) => {
            this.loginRouteCheck()
          },
          (err) => {
            this.setNotification({
              variant: 'danger',
              message: err.message
            })
            this.loadingGoogle = false
          })
    },
    loginGithub: function () {
      this.loadingGithub = true
      fb.providerGithub.addScope('repo')
      fb.auth.signInWithPopup(fb.providerGithub)
        .then(
          (user) => {
            this.loginRouteCheck()
          },
          (err) => {
            this.setNotification({
              variant: 'danger',
              message: err.message
            })
            this.loadingGithub = false
          })
    },
    loginGuest: function () {
      this.loadingEmail = true
      fb.auth.signInAnonymously()
        .then(() => {
          this.loginRouteCheck()
        })
        .catch((err) => {
          this.setNotification({
            variant: 'danger',
            message: err.message
          })
          this.loadingEmail = false
        })
    },
    loginRouteCheck () {
      if (this.loginToPath) {
        this.$router.replace({ path: this.loginToPath })
        this.setLoginToPath(undefined)
      } else this.$router.replace('dashboard')
    }
  }
}
</script>

<style scoped>

</style>
